module.exports = __webpack_public_path__ + "7e4b29ba/img/at-icon.5d6fc5d8.svg";